<template>
    <a-badge :count="recordList.length!==0?recordList.length + '条待处理':0" :offset="[-15,3]">
        <link-button style="margin-left: 50px" @click="$refs.couponPendingList.showModal(recordList)">消费券核销</link-button>
        <coupon-pending-list ref="couponPendingList"/>
    </a-badge>
</template>

<script>
    import LinkButton from "../components/LinkButton";
    import vendorAdmin from "../service/vendorAdmin";
    import CouponPendingList from "./CouponPendingList";

    export default {
        name: "CouponPendingLink",
        components: {CouponPendingList, LinkButton},
        data() {
            return {
                recordList: [],
                interval: 0
            }
        },
        mounted() {
            // 每隔3s获取一次当前商户待处理
            let vm = this
            vm.getPendingRecord()
            this.interval = setInterval(function () {
                vm.getPendingRecord()
            }, 3000)
        },
        beforeDestroy() {
          window.clearInterval(this.interval)
        },
        methods: {
            getPendingRecord() {
                let vm = this
                vendorAdmin.getCouponPendingList().then(value => {
                    vm.recordList = value.data
                })
            }
        }
    }
</script>

<style scoped>

</style>
